export var LinkState;
(function (LinkState) {
    LinkState[LinkState["POSSIBLE"] = 0] = "POSSIBLE";
    LinkState[LinkState["VISITED"] = 1] = "VISITED";
    LinkState[LinkState["DEFAULT"] = 2] = "DEFAULT";
    LinkState[LinkState["ERROR"] = 3] = "ERROR";
})(LinkState || (LinkState = {}));
export var NodeState;
(function (NodeState) {
    NodeState[NodeState["VISITED"] = 0] = "VISITED";
    NodeState[NodeState["DEFAULT"] = 1] = "DEFAULT";
})(NodeState || (NodeState = {}));
